import React from 'react';
import classNames from 'classnames';
import { Bubble } from '@home/components/TeaComponents';
import './index.scss';

const Operation = (props: any) => {
  const { className, bubbleProps, operationList } = props;

  return (
    <div className={classNames('dba-operation-list', className)}>
      {operationList?.map((item: any, index: any) => {
        const {
          icon,
          label: labelText,
          bubble,
          bubbleProps: itemBubbleProps,
          className,
          onClick,
          onMouseEnter,
          onMouseLeave,
        } = item || {};
        return (
          <Bubble
            overlayClassName='dba-nav-menu-overlay'
            key={index}
            content={bubble}
            placementOffset={[0, 8]}
            {...(itemBubbleProps || bubbleProps || {})}
          >
            <div
              className={classNames('dba-operation-list-item', className)}
              onClick={onClick}
              onMouseEnter={onMouseEnter}
              onMouseLeave={onMouseLeave}
            >
              {icon && <img src={icon} alt="" />}
              {labelText && (
                <span className="dba-operation-list-item__label">{labelText}</span>
              )}
            </div>
          </Bubble>
        );
      })}
    </div>
  );
};
export default Operation;
